import { render, staticRenderFns } from "./BtnGoogleLogin.vue?vue&type=template&id=cf4649b6&"
import script from "./BtnGoogleLogin.vue?vue&type=script&lang=js&"
export * from "./BtnGoogleLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports